define('TescoMobile_ClubCard/js/view/what-it-means',['jquery', 'mage/translate', 'TescoMobile_DynamicBundleOptions/js/view/what-it-means', 'ko', '../model/pdp-clubcard-price-provider'], function ($, $t, Component, ko) {
  'use strict';

  return Component.extend({
    defaults: {
      deviceClubCardPrice: null,
      template: 'TescoMobile_ClubCard/what-it-means',
      imports: {
        deviceClubCardPrice: "tm-clubcard-price-provider:deviceClubCardPrice"
      }
    },
    initialize: function () {
      this._super();
      this.totalPhonePaymentClubCard = ko.computed(function () {
        return parseFloat(this.deviceClubCardPrice()) * parseFloat(this.tenure()) + parseFloat(this.puf());
      }, this);
      this.creditAmountClubCard = ko.computed(function () {
        return this.totalPhonePaymentClubCard() - this.puf();
      }, this);
      this.totalPaymentBreakdownClubCard = ko.computed(function () {
        return this.getFormattedPrice(this.deviceClubCardPrice) + ' x ' + this.tenure() + ' ' + $t('months') + ' + ' + this.getFormattedPrice(this.puf) + ' = ';
      }, this);
    },
    initObservable: function () {
      this._super().observe(['deviceClubCardPrice']);
      return this;
    }
  });
});

